function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0l24 24L0 48V0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0l24 24L0 48V0z"
});

function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 24 48"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDI0IDQ4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDBMMjQgMjRMMCA0OEwwIDBaIi8+CiAgPHBhdGggZD0iTTAgMEwyNCAyNEwwIDQ4TDAgMFoiLz4KPC9zdmc+Cg==";
export { SvgRightArrow as ReactComponent };